import type { ReactNode } from 'react';
import AppShell from './AppShell.js';

interface Props {
  children?: ReactNode;
  /** When set, render the minimal layout (no sidebar) — used for login. */
  minimal?: boolean;
}

/**
 * Backwards-compatible alias. New code should import AppShell directly.
 * Old callers (App.tsx, tests) still get a working layout.
 */
export default function AppLayout({ children, minimal }: Props) {
  return <AppShell minimal={minimal}>{children}</AppShell>;
}
